export default __webpack_public_path__ + "static/media/instant-rebate.5462c284.svg";